import { REPORTS_DEFAULT_FILTERS } from '@constants/Reports/reportsDefaultToolbar.constants'

export const PRODUCTION_PERFORMANCE_FILTERS = REPORTS_DEFAULT_FILTERS

export const PRODUCTION_PERFORMANCE_KPI_DEFINITIONS: Array<{
  id: string
  title: string
  footer: string
  format: 'currency'
}> = [
  {
    id: 'production',
    title: 'Production',
    footer: 'Total provider production',
    format: 'currency',
  },
  {
    id: 'production-goal',
    title: 'Production Goal',
    footer: 'target production',
    format: 'currency',
  },
  {
    id: 'avg-production-per-hour',
    title: 'Avg Production per Hour',
    footer: 'Revenue per hour',
    format: 'currency',
  },
  {
    id: 'avg-production-per-day',
    title: 'Avg Production per Day',
    footer: 'Revenue per day',
    format: 'currency',
  },
]
